module.exports = __webpack_public_path__ + "static/media/candle.fc241dc1.svg";